import { useFormContext } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { ContextualBanner } from '@calendly/ui/components/contextual-banner'
import { AlertWarningCircleIcon } from '@calendly/ui/components/icons'
import { BodyText } from '@calendly/ui/components/typography'

import { useEventType } from 'features/event_type_provider'

import { filterEnabledMemberships } from '../helpers'


const AddHostWarning = () => (
  <ContextualBanner variant="danger" icon={AlertWarningCircleIcon}>
    <BodyText>
      {I18n.t('publisher.event_type_editor.sections.scheduling_settings.add_a_host_to_select')}
    </BodyText>
  </ContextualBanner>
)

export const BaseAvailability = ({ children }) => {
  const { isTeam, isMETParent } = useEventType()
  const { values: { memberships } } = useFormContext()

  if (isMETParent) { return children }

  const hosts = isTeam ? filterEnabledMemberships(memberships) : memberships

  if (!hosts.length) { return <AddHostWarning /> }

  return children
}
